import { createContext, useContext, useEffect, useState } from "react";
import capi from "@/lib/customerApi";

const CustomerCtx = createContext(null);

// customer: null = checking, false = signed out, object = signed in
export function CustomerAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null);

  useEffect(() => {
    capi.post("/auth/refresh").then((r) => setCustomer(r.data)).catch(() => setCustomer(false));
  }, []);

  const login = async (identifier, password) => {
    const { data } = await capi.post("/auth/login", { identifier, password });
    setCustomer(data.customer);
    return data.customer;
  };
  const register = async (payload) => {
    const { data } = await capi.post("/auth/register", payload);
    setCustomer(data.customer);
    return data.customer;
  };
  const logout = async () => {
    try { await capi.post("/auth/logout"); } finally { setCustomer(false); }
  };

  return <CustomerCtx.Provider value={{ customer, setCustomer, login, register, logout }}>{children}</CustomerCtx.Provider>;
}

export const useCustomer = () => useContext(CustomerCtx);
